import React,{useState, useEffect} from 'react';
import './App.css';

//router
import { BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';

//redux stuff
import { useSelector, useDispatch} from 'react-redux';
import {setRallyNumber,incrementRallyNumber,setQuestionAnswered,setBestRally} from "./redux/rallyTracker"

//firebase stuff
import {firebase} from './firebase';
import {collectionRef, db} from './firebase';
import { addDoc,deleteDoc, doc, getDocs,updateDoc, collection, query, where,serverTimestamp, getDoc } from 'firebase/firestore';
import {getAuth, createUserWithEmailAndPassword,signOut,signInWithEmailAndPassword,updateProfile} from 'firebase/auth';



function RallyUpdateDB() {
     let dispatch = useDispatch();

     const reduxUserID = useSelector((state) => state.isLoggedIn.reduxUserID);
     const reduxRallyNumber = useSelector((state) => state.rallyTracker.reduxRallyNumber);
     const reduxBestRally = useSelector((state) => state.rallyTracker.reduxBestRally);
     const reduxQuestionAnswered = useSelector((state) => state.rallyTracker.reduxQuestionAnswered);
   
     const [usersRallyID,setUsersRallyID] = useState('temp');
   
     ////get the id of the rally collection, so we can put it in the rallyRef below
     const rallyIDRef = collection(db,'users',reduxUserID,"rally");
   

     

     const rallyIDDocuments = getDocs(rallyIDRef)
     .then((snapshot)=>{
         var dataGrab = new Array(); //which becomes an object for some reason
         snapshot.docs.forEach((doc)=>{
               dataGrab.push({...doc.data(),id:doc.id})  
               console.log('UPDATE -- reduxUserID: ' + reduxUserID);
         })
          setUsersRallyID(dataGrab[0].id);
     }).then(()=>{
          
          
     });
    

     useEffect(() => {
       if(reduxQuestionAnswered == true){
         //if the 'reduxRallyNumber' is greater or equal to the 'reduxBestRally', 
         //set a new BEST by setting 'reduxBestRally' to the 'reduxRallyNumber'
          if(reduxRallyNumber >= reduxBestRally){
               const rallyRef = doc(db,"users",reduxUserID,"rally",usersRallyID);
               updateDoc(rallyRef, { rallyNumber: reduxRallyNumber, bestRally:reduxRallyNumber });
               dispatch(setBestRally(reduxRallyNumber));
          }     
          else{
               const rallyRef = doc(db,"users",reduxUserID,"rally",usersRallyID);
               updateDoc(rallyRef, { rallyNumber: reduxRallyNumber });
          }

       }
     }, [reduxRallyNumber])
   










     return (
          <div>
               
          </div>
     )
}

export default RallyUpdateDB
